import React, { useState } from 'react';
import { FaMicroscope, FaGraduationCap, FaBriefcase, FaAward, FaUniversity, FaHandshake, FaIdBadge } from 'react-icons/fa';
import './Research.css';
import { professorData } from '../data';

export default function Research() {
  const { researchInterests, awards, education, experience, adminPositions, memberships, collaborations } = professorData;
  const [activeTab, setActiveTab] = useState('interests');

  const tabs = [
    { id: 'interests', label: 'Research Interests', icon: <FaMicroscope /> },
    { id: 'education', label: 'Education', icon: <FaGraduationCap /> },
    { id: 'experience', label: 'Academic Experience', icon: <FaBriefcase /> },
    { id: 'awards', label: 'Awards & Honours', icon: <FaAward /> },
    { id: 'admin', label: 'Administrative', icon: <FaUniversity /> },
    { id: 'collab', label: 'Collaborations', icon: <FaHandshake /> },
    { id: 'memberships', label: 'Memberships', icon: <FaIdBadge /> }
  ];

  return (
    <section id="research" className="research section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Academic Profile</span>
          <h2 className="section-title">Research & Experience</h2>
          <div className="section-rule"></div>
        </div>

        <div className="research-dashboard">
          {/* Sidebar */}
          <div className="research-sidebar">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`sidebar-btn ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="sidebar-btn__icon">{tab.icon}</span>
                <span className="sidebar-btn__label">{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Content Area */}
          <div className="research-content">
            
            {activeTab === 'interests' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">Core Research Areas</h3>
                <div className="research__tags-modern">
                  {researchInterests.map((r, i) => (
                    <div key={i} className="modern-tag">
                      <span className="modern-tag__dot"></span>
                      {r}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'education' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">Educational Background</h3>
                <div className="timeline-modern">
                  {education.map((e, i) => (
                    <div key={i} className="timeline-modern__item">
                      <div className="timeline-modern__year">{e.year}</div>
                      <div className="timeline-modern__body">
                        <h4>{e.degree}</h4>
                        <div className="timeline-modern__univ">{e.university}</div>
                        <div className="timeline-modern__div">{e.division}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'experience' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">Professional Journey</h3>
                <div className="experience-modern">
                  {experience.map((e, i) => (
                    <div key={i} className="experience-modern__item">
                      <div className="experience-modern__icon"><FaBriefcase /></div>
                      <div className="experience-modern__info">
                        <h4>{e.role}</h4>
                        <div className="experience-modern__inst">{e.institution}</div>
                        <div className="experience-modern__duration">{e.duration}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'awards' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">Recognitions & Honours</h3>
                <div className="awards-modern">
                  {awards.map((a, i) => (
                    <div key={i} className="awards-modern__item">
                      <div className="awards-modern__year">{a.year}</div>
                      <div className="awards-modern__content">
                        <h4>{a.title}</h4>
                        <p>{a.body}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'admin' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">Leadership Roles</h3>
                <ul className="modern-list">
                  {adminPositions.map((p, i) => (
                    <li key={i}>
                      <span className="modern-list__icon">❖</span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {activeTab === 'collab' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">National Partnerships</h3>
                <ul className="modern-list">
                  {collaborations.map((c, i) => (
                    <li key={i}>
                      <span className="modern-list__icon"><FaHandshake /></span>
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {activeTab === 'memberships' && (
              <div className="research-panel fade-in">
                <h3 className="panel-title">Professional Affiliations</h3>
                <ul className="modern-list">
                  {memberships.map((m, i) => (
                    <li key={i}>
                      <span className="modern-list__icon"><FaIdBadge /></span>
                      {m}
                    </li>
                  ))}
                </ul>
              </div>
            )}

          </div>
        </div>
      </div>
    </section>
  );
}
